import { render } from "./TeamLink.vue?vue&type=template&id=60c60c05"
import script from "./TeamLink.vue?vue&type=script&lang=js"
export * from "./TeamLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__